module.exports = __webpack_public_path__ + "img/Cotton_Harvest.356d985f.jpg";